<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<form [formGroup]="signUpForm">
  <div class="text-center border-bottom mb-3">
    <h5 class="mb-1">Sign Up</h5>
    <p class="mb-3">Create your Account</p>
  </div>
  <div class="mb-2">
    <label class="form-label">First Name</label>
    <div class="input-icon">
      <span class="input-icon-addon">
        <i class="isax isax-user"></i>
      </span>
      <input type="text" class="form-control form-control-lg" placeholder="Enter First Name" formControlName="firstName">
    </div>
  </div>
  <div class="mb-2">
    <label class="form-label">Last Name</label>
    <div class="input-icon">
      <span class="input-icon-addon">
        <i class="isax isax-user"></i>
      </span>
      <input type="text" class="form-control form-control-lg" placeholder="Enter Last Name" formControlName="lastName">
    </div>
  </div>
  <div class="mb-2">
    <label class="form-label">Email</label>
    <div class="input-icon">
      <span class="input-icon-addon">
        <i class="isax isax-message"></i>
      </span>
      <input type="email" class="form-control form-control-lg" placeholder="Enter Email" formControlName="email">
    </div>
  </div>
  <div class="mb-2">
    <label class="form-label">Phone Number</label>
    <div class="input-icon">
      <span class="input-icon-addon">
        <i class="isax isax-user"></i>
      </span>
      <input type="text" class="form-control form-control-lg" placeholder="Enter Phone Number" formControlName="phoneNumber">
    </div>
  </div>
  <div class="mb-2">
    <label class="form-label">Password</label>
    <div class="pass-group input-icon">
      <span class="input-icon-addon">
        <i class="isax isax-lock"></i>
      </span>
      <input [type]="password[1] ? 'text' : 'password'" class="pass-input form-control" placeholder="Enter Password" formControlName="password" />
      <span class="isax toggle-password" [ngClass]="password[1] ? 'isax-eye' : 'isax-eye-slash'"
        (click)="togglePassword(1)" (keydown.enter)="togglePassword(1)" tabindex="0"></span>
    </div>
  </div>
  <div class="mb-2">
    <label class="form-label">Confirm Password</label>
    <div class="pass-group input-icon">
      <span class="input-icon-addon">
        <i class="isax isax-lock"></i>
      </span>
      <input [type]="password[2] ? 'text' : 'password'" class="pass-input form-control" placeholder="Enter Password" formControlName="confirmPassword" />
      <span class="isax toggle-password" [ngClass]="password[2] ? 'isax-eye' : 'isax-eye-slash'"
        (click)="togglePassword(2)" (keydown.enter)="togglePassword(2)" tabindex="0"></span>
    </div>
    <div *ngIf="signUpForm.errors && signUpForm.errors['passwordMismatch'] && (signUpForm.get('confirmPassword')?.touched || signUpForm.get('confirmPassword')?.dirty)" class="text-danger fs-13 mt-1">
      Passwords do not match.
    </div>
  </div>

  <div class="mb-2" *ngIf="otpData">
    <label class="form-label">Enter OTP</label>
    <div class="pass-group input-icon">
      <span class="input-icon-addon">
        <i class="isax isax-lock"></i>
      </span>
      <input type="tel" class="pass-input form-control" [formControl]="otp" placeholder="Enter OTP" />
    </div>

    <div class="d-flex justify-content-between align-items-center mt-1">
      <p class="fs-12 mb-0 message">OTP has been sent to you mail. Please check your inbox.</p>
      <p class="text-decoration-underline text-primary fs-12"><a class="pe-auto" (click)="resendOtp()">Resend OTP</a></p>
    </div>
  </div>

  <div class="mt-3 mb-3">
    <div class="d-flex">
      <div class="form-check d-flex align-items-center mb-2">
        <input class="form-check-input mt-0" type="checkbox" id="agree" formControlName="agree">
        <label class="form-check-label ms-2 text-gray-9 fs-14" for="agree">
          I agree with the <a href="javascript:void(0);" class="link-primary fw-medium">Terms Of Service.</a>
        </label>
      </div>
    </div>
    <div *ngIf="signUpForm.get('agree')?.invalid && (signUpForm.get('agree')?.touched || signUpForm.get('agree')?.dirty)" class="text-danger fs-13 mt-1">
      You must agree to the Terms Of Service.
    </div>
  </div>
  <div class="mb-3" *ngIf="!otpData">
    <button
      type="submit" (click)="signUp()"
      class="btn btn-xl btn-primary d-flex align-items-center justify-content-center w-100"
      [disabled]="signUpForm.invalid">Register<i class="isax isax-arrow-right-3 ms-2"></i>
    </button>
  </div>
    <div class="mb-3" *ngIf="otpData">
    <button (click)="verifyOtp()"
      class="btn btn-xl btn-primary d-flex align-items-center justify-content-center w-100"
      >Verify<i class="isax isax-arrow-right-3 ms-2"></i>
    </button>
  </div>
  <div class="login-or mb-3">
    <span class="span-or">Or</span>
  </div>
  <div class="d-flex align-items-center mb-3">
    <a href="javascript:void(0);" class="btn btn-light flex-fill d-flex align-items-center justify-content-center me-2">
      <img src="assets/img/icons/google-icon.svg" class="me-2" alt="Img">Google
    </a>
    <!-- <a href="javascript:void(0);" class="btn btn-light flex-fill d-flex align-items-center justify-content-center">
      <img src="assets/img/icons/fb-icon.svg" class="me-2" alt="Img">Facebook
    </a> -->
  </div>
  <div class="d-flex justify-content-center">
    <p class="fs-14">Already have an account? <a href="javascript:void(0);" class="link-primary fw-medium"
        data-bs-toggle="modal" data-bs-target="#login-modal">Sign In</a></p>
  </div>
</form>
